import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import FeesFunding from "@/pages/FeesFunding";
import ForReferrers from "@/pages/ForReferrers";
import Contact from "@/pages/Contact";
import Book from "@/pages/Book";
import IndividualTherapy from "@/pages/services/IndividualTherapy";
import CouplesCounselling from "@/pages/services/CouplesCounselling";
import PlayTherapy from "@/pages/services/PlayTherapy";
import VictimsAssist from "@/pages/services/VictimsAssist";
import Emdr from "@/pages/services/Emdr";
import ClinicalSupervision from "@/pages/services/ClinicalSupervision";
import Eap from "@/pages/services/Eap";
import FamilyTherapy from "@/pages/services/FamilyTherapy";
import VeteransDefence from "@/pages/services/VeteransDefence";
import NdisBehaviourSupport from "@/pages/services/NdisBehaviourSupport";
import FamilyLawReports from "@/pages/services/FamilyLawReports";
import Privacy from "@/pages/Privacy";
import Feedback from "@/pages/Feedback";
import CrisisSupport from "@/pages/CrisisSupport";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App min-h-screen bg-euca-mist text-charcoal">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/fees-funding" element={<FeesFunding />} />
          <Route path="/for-referrers" element={<ForReferrers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/book" element={<Book />} />
          <Route path="/services/individual-therapy" element={<IndividualTherapy />} />
          <Route path="/services/play-therapy" element={<PlayTherapy />} />
          <Route path="/services/emdr" element={<Emdr />} />
          <Route path="/services/victims-assist" element={<VictimsAssist />} />
          <Route path="/services/clinical-supervision" element={<ClinicalSupervision />} />
          <Route path="/services/eap" element={<Eap />} />
          <Route path="/services/couples-counselling" element={<CouplesCounselling />} />
          <Route path="/services/family-therapy" element={<FamilyTherapy />} />
          <Route path="/services/veterans-defence" element={<VeteransDefence />} />
          <Route path="/services/ndis-behaviour-support" element={<NdisBehaviourSupport />} />
          <Route path="/services/family-law-reports" element={<FamilyLawReports />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/crisis-support" element={<CrisisSupport />} />
        </Routes>
        <Footer />
      </div>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
